<template>
    <div class="col-12">
        <div class="info-box">
            <span class="info-box-icon bg-info"><i :class="icon"></i></span>

            <div class="info-box-content">
                <span class="info-box-text">{{ title }}</span>
                <span class="info-box-number">{{ data }}</span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['icon', 'title', 'data']
    }
</script>
